<template>
  <profitability
    dashboard-view
    :title="$t('Dashboard.Banking.AssetAndLiabilityManagement.Title')"
    :title-icon="'grey'"
    :title-icon-size="5"
  />
</template>

<script>
import Profitability from '@/theme/default/views/banking/alm/summary/blocks/Profitability.vue'
import API from '@/api/Api'
import { clone } from '@/lib/utils/helper'
import ALMSummaryResource from '@/api/resources/alm/ALMSummaryResource'

export default {
  name      : 'AssetAndLiabilityManagement',
  components: {
    Profitability
  },
  dataStore: {
    ALMSummary: 'ALM.ALMSummary.Data'
  },
  data () {
    return {

    }
  },
  computed: {
    accountId () {
      return this.user?.selectedAccountId || null
    }
  },
  created () {
    this.getData()
  },
  methods: {
    getData () {
      const params = [this.accountId]
      API.Resource.ALM.GetALMSummary(...params)
        .then(response => {
          this.handleResponse(response)
        })
        .catch(e => {
          this.handleResponse(e.response)
        })
        .finally(() => {})
    },
    handleResponse (response) {
      const data = API.responseData(response)?.findALMInfo || null
      const errors = API.responseErrors(response) || []

      if (API.isResponseSuccess(response) && data) {
        const o = clone(data)
        this.ALMSummary = new ALMSummaryResource(o)
      } else {
        this.ALMSummary = null
        this.$bus.$emit('app:error', errors)
      }
    }
  }
}
</script>

<style scoped>
.asset-liability-management {
  padding: 20px;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.section-title {
  font-family: Inter, Aeonik, Roboto, sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: var(--v-synthesis-ui-grey-01-base);
  margin: 0 0 16px 0;
}

.management-table {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.table-header {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1fr;
  gap: 12px;
  padding: 8px 12px;
  font-weight: 600;
  font-size: 12px;
  color: var(--v-synthesis-ui-grey-01-base);
  border-bottom: 1px solid #e9ecef;
}

.table-row {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1fr;
  gap: 12px;
  padding: 12px;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 500;
}

.table-row.loans {
  background-color: #e8f5e8;
}

.table-row.deposits {
  background-color: #fff3e0;
}

.table-row.investments {
  background-color: #e3f2fd;
}

.table-row.net-interest-income {
  background-color: #f5f5f5;
}

.activity-cell {
  display: flex;
  align-items: center;
  gap: 8px;
}

.activity-indicator {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
}

.activity-indicator.green {
  background-color: #4caf50;
}

.activity-indicator.orange {
  background-color: #ff9800;
}

.activity-indicator.blue {
  background-color: #2196f3;
}

.activity-indicator.grey {
  background-color: #9e9e9e;
}

.value-cell, .yield-cell {
  text-align: right;
  color: var(--v-synthesis-ui-grey-01-base);
}

.yield-cell {
  font-weight: 600;
}
</style>
